/**
 * Stylized mockup of NIS360 team management (roles & responsibilities) used as
 * a screenshot stand-in on marketing pages. Texts are intentionally hardcoded
 * German, exactly like a real product screenshot would be.
 */

const MEMBERS: { initials: string; name: string; role: string; tasks: string; color: string }[] = [
	{
		initials: "TK",
		name: "Thomas König",
		role: "IT-Leitung",
		tasks: "12 Aufgaben",
		color: "#1A2E6E",
	},
	{
		initials: "SM",
		name: "Sandra Meyer",
		role: "Geschäftsführung",
		tasks: "4 Aufgaben",
		color: "#2F62D9",
	},
	{
		initials: "JR",
		name: "Julia Roth",
		role: "Datenschutz",
		tasks: "7 Aufgaben",
		color: "#7C5CFC",
	},
	{
		initials: "AM",
		name: "Andreas Maier",
		role: "IT-Administration",
		tasks: "9 Aufgaben",
		color: "#2AA216",
	},
];

export default function TeamMockup() {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex items-center justify-between">
				<p className="font-urbanist text-[13px] font-bold text-[#1D243C]">Ihr Compliance-Team</p>
				<span className="font-urbanist text-[10px] font-semibold text-white bg-[#4680FC] rounded-lg px-2.5 py-1">
					+ Mitglied einladen
				</span>
			</div>
			<div className="flex flex-col gap-2">
				{MEMBERS.map((member) => (
					<div
						key={member.name}
						className="flex items-center gap-3 bg-white border border-[#E6E6EC] rounded-lg px-3 py-2.5"
					>
						<span
							className="w-7 h-7 shrink-0 rounded-full text-white text-[10px] font-semibold flex items-center justify-center font-urbanist"
							style={{ backgroundColor: member.color }}
						>
							{member.initials}
						</span>
						<div className="flex flex-col gap-0.5 min-w-0">
							<p className="font-urbanist text-[11px] font-semibold text-[#1D243C] truncate">
								{member.name}
							</p>
							<p className="font-urbanist text-[9px] text-[#626373]">{member.tasks}</p>
						</div>
						<span className="ml-auto shrink-0 font-urbanist text-[9px] font-semibold text-[#2F62D9] bg-[#E2ECFF] px-1.5 py-0.5 rounded">
							{member.role}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}
